<template>
  <div>
    <Loading v-if="loading" />
    <BaseModal
      :showing="visible"
      overflowable
      @close="$emit('close')"
      @opened="onOpened"
    >
      <BaseCard
        :title="`${id ? 'Edit' : 'Tambah'} Kebijakan Wilayah Harga`"
        :description="`Kebijakan wilayah harga ${destinationOfficeTypeLabel} ke PUSAT dan KP`"
        :with-style="false"
      >
        <form
          v-if="!loadingEdit"
          class="space-y-4 border-t pt-6"
          @submit.prevent="onSubmit"
        >
          <BaseInput label="Metode Pengiriman">
            <div class="flex gap-8">
              <BaseRadio
                label="Diambil"
                val="pickup"
                id="tipe_diambil"
                v-model="form.type"
              />
              <BaseRadio
                label="Dikirim"
                val="delivery"
                id="tipe_dikirim"
                v-model="form.type"
              />
            </div>
          </BaseInput>

          <BaseInput label="Tipe Kantor Tujuan">
            <div class="flex gap-8">
              <BaseRadio
                label="Pusat"
                val="pusat"
                id="tipe_pusat"
                v-model="form.originOfficeType"
              />
              <BaseRadio
                label="KP"
                val="kp"
                id="tipe_kp"
                v-model="form.originOfficeType"
              />
            </div>
          </BaseInput>

          <BaseInput
            required
            label="Kode Pusat / KP"
            fullwidth
            :shadow="false"
            :disabled="form.originOfficeType === 'pusat'"
            value="PUSAT"
          >
            <OfficeSelectSearch
              v-if="form.originOfficeType === 'kp'"
              fullwidth
              :shadow="false"
              :office-category-id="2"
              required
              v-model="form.originOffice"
            />
          </BaseInput>

          <BaseInput required :label="`Kode ${destinationOfficeTypeLabel}`">
            <OfficeSelectSearch
              fullwidth
              :shadow="false"
              :office-category-id="destinationOfficeType === 'stockist' ? 4 : 3"
              required
              v-model="form.destinationOffice"
            />
          </BaseInput>

          <BaseInput required label="Wilayah Harga">
            <BaseSelect
              :options="areasOption"
              expand
              :shadow="false"
              required
              v-model="form.area"
            ></BaseSelect>
          </BaseInput>

          <div class="flex justify-end gap-1">
            <BaseButton color="white" type="button" @click="$emit('close')"
              >Batal</BaseButton
            >
            <BaseButton>Simpan</BaseButton>
          </div>
        </form>
      </BaseCard>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';
import BaseModal from '../../../base/BaseModal.vue';
import BaseRadio from '../../../base/BaseRadio.vue';
import OfficeSelectSearch from '../../../office/office-select-search.vue';

export default {
  mixins: [requestMixin],
  components: { BaseModal, BaseRadio, OfficeSelectSearch },
  props: {
    id: String,
    visible: Boolean,
    destinationOfficeType: String
  },
  emits: ['close', 'saved'],
  data() {
    return {
      areas: {
        data: [],
      },
      pusat: null,
      form: {
        type: 'pickup',
        originOfficeType: 'pusat',
        originOffice: null,
        destinationOffice: null,
        area: null,
      },
      hideFormModal: true,
      loadingAreas: false,
      loadingSubmit: false,
      loadingPusat: false,
      loadingEdit: false,
    };
  },
  computed: {
    destinationOfficeTypeLabel() {
      return {
        stockist: 'Stockist',
        stockist_center: 'Stockist Center'
      }[this.destinationOfficeType]
    },
    loading() {
      return this.loadingSubmit || this.loadingEdit;
    },
    areasOption() {
      return [
        {
          key: 'null',
          label: 'Pilih Area',
          value: null,
        },
        ...this.areas.data.map((area) => ({
          key: area.id,
          label: area.attributes.name,
          value: area.id,
        })),
      ];
    },
    originOffice() {
      if (this.form.originOfficeType === 'pusat') {
        return this.pusat.attributes.office_id;
      }

      if (!this.form.originOffice?.id) {
        return null;
      }

      return this.form.originOffice.attributes.office_id;
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadAreas() {
      this.loadingAreas = true;

      const [res, err] = await this.request(`/api/v1/areas`, {
        params: {
          'fields[areas]': 'name',
        },
      });

      if (!err) {
        this.areas = res;
      }

      this.loadingAreas = false;
    },
    async loadEdit() {
      this.loadingEdit = true;

      const [res, err] = await this.request(`/api/v1/order-routes/${this.id}`, {
        params: {
          'fields[order-routes]':
            'shipment_type,origin-office,destination-office,area',
          'fields[offices]': 'code,name,office_type',
          'fields[areas]': 'name',
          include: 'origin-office,destination-office,area',
        },
      });

      if (!err) {
        this.form.type = res.data.attributes.shipment_type;
        this.form.area = res.data.relationships.area.data.id;

        const originOffice = this.getSingleIncluded(
          res,
          res.data.relationships['origin-office'].data.id
        );
        const destinationOffice = this.getSingleIncluded(
          res,
          res.data.relationships['destination-office'].data.id
        );

        this.form.originOfficeType =
          originOffice.attributes.office_type === 'pusat' ? 'pusat' : 'kp';

        if (this.form.originOfficeType === 'kp') {
          this.form.originOffice = {
            id: originOffice.id,
            attributes: {
              office_id: originOffice.id,
              code: originOffice.attributes.code,
            },
          };
        }

        this.form.destinationOffice = {
          id: destinationOffice.id,
          attributes: {
            office_id: destinationOffice.id,
            code: destinationOffice.attributes.code,
          },
        };
      }

      this.loadingEdit = false;
    },
    async loadPusat() {
      this.loadingPusat = true;

      const [res, err] = await this.request(`/api/v1/offices`, {
        params: {
          'filter[code]': 'pusat',
          'fields[simple-offices]': 'office_id',
        },
      });

      if (!err) {
        this.pusat = res.data[0];
      }

      this.loadingPusat = false;
    },
    async onSubmit() {
      this.loadingSubmit = true;

      const [, err] = await this.request(
        this.id ? `/api/v1/order-routes/${this.id}` : `/api/v1/order-routes`,
        {
          method: this.id ? 'patch' : 'post',
          data: {
            data: {
              type: 'order-routes',
              ...(this.id ? { id: this.id } : {}),
              attributes: {
                shipment_type: this.form.type,
              },
              relationships: {
                'origin-office': {
                  data: this.originOffice
                    ? {
                        type: 'offices',
                        id: this.originOffice,
                      }
                    : null,
                },
                'destination-office': {
                  data: this.form.destinationOffice?.id
                    ? {
                        type: 'offices',
                        id: this.form.destinationOffice.attributes.office_id,
                      }
                    : null,
                },
                area: {
                  data: {
                    type: 'areas',
                    id: this.form.area,
                  },
                },
              },
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          type: 'confirm',
          status: 'error',
          data: this.getRequestErrorMessage(err),
          autoClose: false,
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Data berhasil disimpan',
        });

        this.$emit('close');
        this.$emit('saved');
      }

      this.loadingSubmit = false;
    },
    onOpened() {
      this.form.type = 'pickup';
      this.form.originOfficeType = 'pusat';
      this.form.originOffice = null;
      this.form.destinationOffice = null;
      this.form.area = null;

      if (this.id) {
        this.loadEdit();
      }
    },
  },
  created() {
    this.loadAreas();
    this.loadPusat();
  },
};
</script>
